import React from 'react'
import { Chart } from 'react-google-charts'
import { GoogleChartWrapper } from 'react-google-charts/dist/types';
import { DataSource } from '..';
import { CHART_DEFAULTS, GenerateChartsProps } from '../GenerateCharts';

const WIDTH = 300;
const HEIGHT = 300;

export interface BoardDiversityDataSource extends DataSource {
  disabilityTotal?: number;
  minorityTotal?: number;
  otherTotal?: number;
}

const BoardDiversity = React.memo((props: GenerateChartsProps) => {
  const { questionData, updateData } = props;

  const utrv = questionData.find(d => d.universalTracker.code === 'gri/2020/405-1/a');
  const data = utrv?.valueData?.table?.[0];

  const male = Number(data?.find(d => d.code === 'male')?.value) ?? 0;
  const female = Number(data?.find(d => d.code === 'female')?.value) ?? 0;
  const disabilityTotal = Number(data?.find(d => d.code === 'disability')?.value) ?? 0;
  const minorityTotal = Number(data?.find(d => d.code === 'minority')?.value) ?? 0;

  const totalGender = male + female;
  const totalDiversity = disabilityTotal + minorityTotal;

  const reportData: BoardDiversityDataSource = {
    loaded: true,
    width: WIDTH,
    height: HEIGHT,
    disabilityTotal: disabilityTotal,
    minorityTotal: minorityTotal,
    otherTotal: totalGender > totalDiversity ? totalGender - totalDiversity : 0,
  }

  const chartData = [
    ['Group', 'Count'],
    ['Disability', reportData.disabilityTotal],
    ['Minority', reportData.minorityTotal],
    ['Other', reportData.otherTotal],
  ];

  return <Chart
    chartType='PieChart'
    data={chartData}
    width={WIDTH}
    height={HEIGHT}
    options={CHART_DEFAULTS.OPTIONS}
    chartEvents={[
      {
        eventName: 'ready',
        callback: (ChartRef: { chartWrapper: GoogleChartWrapper }) => {
          reportData.chart = (ChartRef.chartWrapper.getChart().getImageURI() as unknown as string).split(',')[1];
          updateData('boardDiversity', reportData);
        }
      }
    ]}
  />
})

export default BoardDiversity;
